module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/stat/chart.component.html
// module id = 356
// module chunks = 0